export * from "./patient-portal-verify-pin.guard";
export * from "./patient-portal-dashboard-access.guard";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/guard/patient-portal/index.ts